import { CloseRounded } from "@mui/icons-material";
import { Divider, IconButton } from "@mui/material";
import React from "react";
import Details from "./Details";
import Items from "./Items";

const ViewDetails = ({ setShowForm, values }) => {
  const handleClose = () => {
    setShowForm(false);
  };

  return (
    <div className="flex flex-col max-h-[90vh]">
      {/* ======= Header ======== */}
      <div className="flex justify-between items-center gap-2 border-b p-[5px]">
        <span className="text-[18px] ml-[5px] uppercase text-gray-500 font-medium">
          Print Label Details
        </span>
        <div>
          <IconButton size="small" onClick={handleClose}>
            <CloseRounded />
          </IconButton>
        </div>
      </div>

      {/* ======= Body ======== */}
      <div className="grid gap-2 text-gray-600">
        {/* ---- Details ---- */}
        <Details values={values} />
        <Divider />
        {/* ---- Items ---- */}
        <Items values={values} />
        <div></div>
      </div>
    </div>
  );
};

export default ViewDetails;
